/**
 * @file 常见问题
 * @author chenyuyang
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import './index.less';

export class Help extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            type: false,
            step: 2,
            formData: {
                phoneMark: ''
            },
            checkboxValue: false
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    jump = (type) => {
        switch (type) {
            case 'partner':
                this.props.history.push('/partner');
                break;
            case 'userCenter':
                this.props.history.push('/user_center/my_attest');
                break;
            case 'guide':
                this.props.history.push('/companyGuide');
                break;
            case 'attest':
                this.props.history.push('/attest');
                break;
            case 'appeal':
                this.props.history.push('/appeal?pagef=helpPage');
                break;
            default:
        }
    };

    render() {
        return (
            <div className={'help'}>
                <div className={'page-title'}>
                    常见问题：
                </div>

                <ul className={'con'}>
                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>什么是企业号码认证？</div>
                        </div>
                        <div className="answer">
                            <div>
                                百度“企业号码认证”是百度提供的一项付费服务，这项服务可以让企业在百度搜索结果中展示包含企业名称、电话号码、企业logo及号码名称等信息的号码认证卡片。
                                {/* <span className="jump" onClick={() => this.jump('appeal')}>企业申诉</span>。 */}
                            </div>
                            <div>
                                “企业号码认证”为企业打造了一张“电子名片”，通过在搜索结果中展示企业的认证号码信息，提升企业的品牌形象和号码的可信度，帮助企业与用户建立信任！
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>为什么要进行企业号码认证？</div>
                        </div>
                        <div className="answer">
                            <div>
                                防止误标记：通过认证的企业号码将无法被百度标记为骚扰或诈骗电话，确保企业的电话能够准确无误地传达给目标客户。
                            </div>
                            <div>
                                建立信任：号码认证平台的官方性质保证了信息的真实性与可靠性，为个人和企业的通信交互筑牢信任基石。
                            </div>
                            <div>
                                丰富曝光路径：企业认证成功后，可以在百度PC、WISE、百度号码助手小程序以及百度号码认证网站等位置展示企业信息。
                            </div>
                            <div>
                                提升品牌形象：百度为企业提供最权威的第三方认证，为企业塑造可靠的形象，让用户在纷杂的信息中一眼看到你。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>号码认证有哪些类型？</div>
                        </div>
                        <div className="answer">
                            <div>
                                <div>
                                    {'客服热线认证：客服热线认证适用于认证企业官方电话。认证成功后，用户可以通过号码或者企业信息关键字检索到企业认证卡片。'}
                                    {'卡片内支持展示企业logo、企业号码、号码名称等，并且可以设置不同的落地页。'}
                                </div>
                                <div>
                                    {'企业标记认证：企业标记适用于物流快递等公司标记属于本公司的配送人员等。用户搜索指定号码信息查询当前号码标记的企业信息，'}
                                    {'从而提升企业业务开展的效率和完成率。'}
                                </div>
                                <div>
                                    {'政府号码认证：政府号码认证有助于政府和非盈利机构在提供服务时保持信息的公开和透明。及时更新政府发布的信息和通知，'}
                                    {'确保新信息被用户接收和信任。增强公众的满意度的同时降低诈骗风险。'}
                                </div>
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>为什么企业号码认证会被拒绝？</div>
                        </div>
                        <div className="answer">
                            <div>
                                {'企业号码认证被拒绝有以下三种情况：1、企业合法资质、商标证、运营商证明等提交不全或错误。2、企业名称与认证证明中的企业名称不一致。'}
                                {'3、企业号码已被认证，如需更改认证信息，请进行'}
                                <span className="jump" onClick={() => this.jump('appeal')}>号码申诉反馈</span>。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>为什么企业/个人号码在号码申诉时会被拒绝？</div>
                        </div>
                        <div className="answer">
                            <div>
                                企业/个人号码申诉被拒绝有以下两种情况：1、提交的申诉资料不全或错误。2、近期内确实存在较多用户标记，不予撤销。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>如何认证我的企业电话号码？</div>
                        </div>
                        <div className="answer">
                            <div>
                                <div>
                                    1、在百度号码服务平台，点击“立即申请”，提交您的企业信息和联系方式。
                                </div>
                                <div>
                                    2、百度官方<span className="jump" onClick={() => this.jump('partner')}>合作伙伴</span>
                                    {'将与您电话联系，为您提供一对一协助，进行号码认证服务。'}
                                </div>
                                <div>
                                    3、认证资质审核通过，完成付费，您的企业号码认证顺利上线。
                                </div>

                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>企业号码认证如何收费？</div>
                        </div>
                        <div className="answer">
                            <div>
                                按年计费包年服务，您可以提交企业的信息到平台，平台会自动为您计算费用，或者您可以找您当地
                                <span className="jump" onClick={() => this.jump('partner')}>合作伙伴</span>
                                为您线下评估。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>提交联系信息后，什么时候会和我联系？</div>
                        </div>
                        <div className="answer">
                            <div>
                                {'合作伙伴会在7个工作日内与您联系。如果超过7日未获得联系，您可以发送邮件至haomakefu@baidu.com进行咨询，'}
                                {'平台会直接为您提供服务。'}
                            </div>
                        </div>
                    </li>
                    {/* 认证常见问题 */}
                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>提交资料后，什么时候会审核完毕？</div>
                        </div>
                        <div className="answer">
                            <div>
                                提交资料后，工作人员会在提交后的两个工作日内审核完毕。特殊认证号码可在
                                <span className="jump" onClick={() => this.jump('userCenter')}>&quot;个人中心&quot;</span>
                                处查看审核结果。其他企业号码认证请联系
                                <span className="jump" onClick={() => this.jump('partner')}>合作伙伴</span>。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>百度号码服务平台是否会泄露企业/个人身份信息？</div>
                        </div>
                        <div className="answer">
                            <div>
                                {'百度号码服务平台是国内著名号码安全平台，首先保证的就是您手机中各类信息的安全，对于您提交的有关信息，'}
                                {'我们会进行严格保密，不会泄露任何信息，请您放心提交。'}
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>举报后的号码将会如何处理？</div>
                        </div>
                        <div className="answer">
                            <div>
                                当号码被举报次数超过一定量时，将会把该号码正式标记为相关类型，以展示给百度用户。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>我的企业号码被错误标记，怎么办？</div>
                        </div>
                        <div className="answer">
                            <div>
                                您可以通过<span className="jump" onClick={() => this.jump('appeal')}>号码申诉反馈</span>，
                                {'直接在线取消错误的号码标记显示。如果您希望在百度搜索中展示您企业的正确品牌和号码，您可以填写联系方式进行'}
                                <span className="jump" onClick={() => this.jump('attest')}>企业号码认证</span>。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>企业/个人号码申诉成功后，为什么百度搜索或通话时还会显示标记？</div>
                        </div>
                        <div className="answer">
                            <div>
                                {'申诉成功后，百度搜索显示标记是由于搜索中的数据需等待数据更新后才能不再显示，存在一定的延迟，请耐心等待；'}
                                {'通话时还在显示标记时，您可以在通话列表中点击进入号码详情，根据页面中显示的数据标记来源，到相应的数据来源方官网进行标记申诉。'}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}

Help.propTypes = {
    history: PropTypes.object,
};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps() {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Help));